import type { DraftResumeInconsistency } from "@/types/cat/drafts";
import { create } from "zustand";

type DraftResumeStore = {
  inconsistencies: DraftResumeInconsistency[];
  setInconsistencies: (items: DraftResumeInconsistency[]) => void;
  clearInconsistencies: () => void;
};

export const useDraftResumeStore = create<DraftResumeStore>((set) => ({
  inconsistencies: [],
  setInconsistencies: (items) => set({ inconsistencies: items }),
  clearInconsistencies: () => set({ inconsistencies: [] }),
}));
